var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "id_6 clear" }, [
    _c(
      "div",
      {
        staticClass: "img_box imgBox",
        style: _vm.data.bol
          ? { zoom: _vm.data.zoom ? _vm.data.zoom : "100%" }
          : { width: _vm.data.zoom ? _vm.data.zoom : "100%" }
      },
      [
        _vm.data.url
          ? _c("a", { attrs: { href: _vm.data.url, target: "_blank" } }, [
              _c("img", { ref: "img", attrs: { src: _vm.data.src } })
            ])
          : _c("img", { ref: "img", attrs: { src: _vm.data.src } })
      ]
    ),
    _vm._v(" "),
    _vm.data.title
      ? _c("div", {
          staticClass: "title",
          domProps: { innerHTML: _vm._s(_vm.data.title) }
        })
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-loader/node_modules/vue-hot-reload-api")      .rerender("data-v-807809b2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-807809b2","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/components/module/course/public/id_6.vue
// module id = null
// module chunks = 